import {generateAsyncActionCreators} from '../core/reduxUtils';

const sendMessageActionCreators = generateAsyncActionCreators(
  'SEND_MESSAGE',
  (params) => ({
    params,
  })
);

const deleteChatActionCreators = generateAsyncActionCreators(
  'DELETE_CHAT',
  (params) => ({
    params,
  })
);


const actionCreators = {
  sendMessage:{
    ...sendMessageActionCreators,
  },
  deleteChat:{
    ...deleteChatActionCreators,
  },
  clearError() {
    return {
      type: 'CLEAR_ERROR',
      payload: {},
    };
  },
  approveContract() {
    return {
      type: 'APPROVE_CONTRACT',
      payload: {},
    };
  },
  setTermsOfUseModal(value) {
    return {
      type: 'SET_TERMS_OF_USE_MODAL',
      payload: {
        value
      },
    };
  }
};


export {
  actionCreators,
  sendMessageActionCreators,
  deleteChatActionCreators,
};
